    <template>
        <div class="googlemapsinterface">
           <div v-if="!showfiltercollection && pd.length!=0" id="mainmapsviewholder">

                <transition name="slide-fade">
                    <div class="container row bottom noclick"  v-if="showparktijkview">
                        <div class="col-md-offset-2 col-md-8 col-lg-5">

                            <div class="btn-group enableclick"  role="group" v-if="!showfysioview && markerdata.length>1"  >
                                <button class="btn btn-primary btn-sm btn-iconbtn button-h-sm" v-on:click="prevpraktijk" v-bind:disabled="leftButtonDisabled" ><i class="fa fa-caret-left caretsize" aria-hidden="true"></i></button>
                                <button class="btn btn-primary btn-sm btn-icontextbtn button-h-sm" >{{pdindex+1}} {{$store.state.translation[2030]}} {{markerdata.length}}</button>
                                <button class="btn btn-primary btn-sm btn-iconbtn button-h-sm" v-on:click="nextpraktijk" v-bind:disabled="rightButtonDisabled"><i class="fa fa-caret-right caretsize" aria-hidden="true" ></i></button>
                            </div>
                            <div class="infoview praktijkview enableclick selecttext" v-if="!showfysioview">
                                <div class="fysiodatawrap praktijkview">
                                    <div class="infoviewhead ">{{pd[pdindex].tblSKFVestigingNaam}}</div> 
                                    <address>
                                        <p>
                                            {{pd[pdindex].tblSKFVestigingStraat}} {{pd[pdindex].tblSKFVestigingHuisnummer}} {{pd[pdindex].tblSKFVestigingHuisnummerToevoeging}}<br />

                                            {{pd[pdindex].tblSKFVestigingPostcode}} {{pd[pdindex].tblSKFVestigingPlaats}}
                                        </p>
                                        <p><a v-bind:href="pd[pdindex].tblSKFVestigingTelefoon">{{pd[pdindex].tblSKFVestigingTelefoon}}</a><br /></p>

                                        <p>
                                            <a  target="_blank" v-bind:href="pd[pdindex].tblSKFVestigingWebsite"> {{$store.state.translation[8944]}}</a><br />
                                            <a v-bind:href="'mailto:' + pd[pdindex].tblSKFVestigingEmail">    {{$store.state.translation[14164]}}</a>
                                        </p>
                                        <p>{{pd[pdindex].PraktijkAgbCode}}</p>
                                        <br />
                                    </address>
                                </div>
                            </div>
                            <div class="infoview enableclick">
                                <button type="button" v-on:click="showfysio(pd[pdindex].tblPersonID)" class="btn btn-primary btn-sm button-h-sm  btn-icontextbtn btn-block">
                                    <i class="fa caretsize pull-left poscaret-down  " v-bind:class="[showfysioview ? 'fa-caret-down': 'fa-caret-up']" aria-hidden="true" ></i><span>{{$store.state.translation[14133]}}</span> <!--<span class="badge">14</span>-->
                                </button>
                                <!--<div class="input-group infoviewgap" v-if="showfysioview">
                                    <span class="input-group-btn">
                                        <button type="button" class="btn btn-default  ">
                                            <i class="fa fa-search "></i>
                                        </button>
                                    </span>
                                    <input class="form-control" v-model="zoekprof" placeholder="Zoek op naam..." />
                                </div>-->
                                <div class="fysiodatawrap infoviewgap" v-if="showfysioview">
                                    <div class="pull-left fysodatanav"  v-on:click="profprev()">
                                        <i class="fa fa-play-circle fa-2x fa-flip-horizontal" aria-hidden="true"></i>
                                    </div>
                                    <div class="fysiodata selecttext" v-if="fysiodetails.length!=0">
                                        <div class="indexfysio pull-right">
                                            {{fysioselected+1}}/{{fysiodetails.length}}
                                        </div>
                                        <p>
                                            {{fysiodetails[fysioselected].voornaam}} {{fysiodetails[fysioselected].tussenvoegsel}} {{fysiodetails[fysioselected].achternaam}}
                                        </p>
                                        <p>
                                            BIG-Nummer<br />
                                            {{fysiodetails[fysioselected].biGnummer}} 

                                            AGB-code<br />
                                            {{fysiodetails[fysioselected].agBcode}}
                                            
                                        </p>
                                        <p class="filtertags">
                                            <span>{{$store.state.translation[14162]}}</span>
                                            <ul id="filtertags"  style="display: inline;">
                                                <li v-for="(spec,index) in specialismes.filter(spec => spec.tblPersonID==fysiodetails[fysioselected].tblPersonID)" :key="index"  class="tags" ><span>{{spec.specialisme}}</span></li>
                                            </ul>
                                        </p>
                                    </div>
                                    <div class="pull-right fysodatanav" v-on:click="profnext()">
                                        <i class="fa fa-2x fa-play-circle" aria-hidden="true"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </template>
    <script>
'use strict'
import axios from 'axios'
export default {
  props: {
    showfysioview: {
      type: Boolean,
      default: false,
    },
    showparktijkview: {
      type: Boolean,
      default: false,
    },
    showfiltercollection: {
      type: Boolean,
      default: false,
    },
    markerdata: {
      type: Array,
      default() {
        return []
      },
    },
  },
  watch: {
    markerdata: function (newVal, oldVal) {
      // watch it
      var data = { praktIDs: newVal }
      this.pdindex = 0

      this.leftButtonDisabled = true
      this.rightButtonDisabled = false
      axios
        .post(`SKF_Praktijken_Register.aspx/GetmapsDatainfo`, data, {
          headers: { 'Content-Type': 'application/json; charset=utf-8; multipart/form-data;' },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.pd = JSON.parse(response.data.d)
        })
        .catch((e) => {
          console.log(e)
        })
    },
  },
  data() {
    return {
      infoboxes: [],
      icons: [],
      map: '',
      card: '',
      pd: [],
      pdindex: 0,
      leftButtonDisabled: true,
      rightButtonDisabled: false,
      fysiodetails: [],
      fysioselected: 0,
      zoekprof: '',
      specialismes: [],
    }
  },
  created() {},
  methods: {
    profnext: function () {
      if (this.fysioselected < this.fysiodetails.length - 1) {
        this.fysioselected++
      }
    },
    profprev: function () {
      if (this.fysioselected > 0) {
        this.fysioselected--
      }
    },
    showfysio: function (praktID) {
      this.fysioselected = 0
      var data = { praktID: praktID }
      this.fysiodetails = []
      axios
        .post(`SKF_Praktijken_Register.aspx/GetfysioData`, data, {
          headers: { 'Content-Type': 'application/json; charset=utf-8; multipart/form-data;' },
        })
        .then((response) => {
          this.fysiodetails = JSON.parse(response.data.d.fysioinfo)
          this.specialismes = JSON.parse(response.data.d.specialismes)
        })
        .catch((e) => {
          console.log(e)
        })
      this.$emit('showfysio')
    },
    nextpraktijk: function () {
      if (this.pdindex < this.pd.length - 1) {
        if (this.pdindex === this.pd.length - 2) {
          this.rightButtonDisabled = true
        }
        this.leftButtonDisabled = false

        this.pdindex++
      } else {
        this.rightButtonDisabled = true
      }
    },
    prevpraktijk: function () {
      if (this.pdindex > 0) {
        this.pdindex--
        if (this.pdindex === 0) {
          this.leftButtonDisabled = true
        }
        this.rightButtonDisabled = false
      } else {
        this.leftButtonDisabled = true
      }
    },
  },
  computed: {},
}
</script>
                                    
